import request from 'superagent';

import { CUSTOMERS_URL } from 'constants/Jaws';

export function validate(customerNumber, data, callback) {
  request
    .post(`${CUSTOMERS_URL}/${customerNumber}/orders/validate`)
    .send({ data })
    .end(callback);
}

export function execute(customerNumber, data, callback) {
  request
    .post(`${CUSTOMERS_URL}/${customerNumber}/orders/execute`)
    .send({ data })
    .end(callback);
}

export function validateModify(customerNumber, orderId, data, callback) {
  request
    .put(`${CUSTOMERS_URL}/${customerNumber}/orders/${orderId}/validate`)
    .send({ data })
    .end(callback);
}

export function modify(customerId, data, callback) {
  request
    .put(`${CUSTOMERS_URL}/${customerId}/orders/${data.ORDER_ID}/execute`)
    .send({ data })
    .end(callback);
}

export function getDetails(customerNumber, customerId, orderId, callback) {
  request
    .get(`${CUSTOMERS_URL}/${customerNumber}/orders/${orderId}`)
    .query({ customerId })
    .end(callback);
}

export function deleteOrder(customerNumber, customerId, orderId, callback) {
  request
    .del(`${CUSTOMERS_URL}/${customerNumber}/orders/${orderId}`)
    .query({ customerId })
    .end(callback);
}

// Se http://manawiki.osl.manamind.com/index.php/Meglersystemer
export function mapStatus(statusInt) {
  // TODO: Hvilken er "aktiv"?
  return (
    {
      0: 'Registrert',
      1: 'Avvist',
      2: 'På børs',
      3: 'Venter',
      4: 'Utført',
      5: 'Kansellert',
      6: 'Utgått',
      7: 'Trukket',
      // sic: There was no 8
      9: 'Manuell',
      10: 'Manuelt utgått',
    }[statusInt] || '-'
  );
}

export function orderStatusMapping(statusInt) {
  return (
    {
      0: 'Mottatt',
      1: 'Avvist',
      2: 'Aktiv',
      3: 'Fremtidig',
      4: 'Utført',
      5: 'Kansellert',
      6: 'Utgått',
      7: 'Aktiv',
    }[statusInt] || '-'
  );
}

export function mapType(typeInt) {
  return (
    {
      0: 'Kjøp',
      1: 'Selg',
    }[typeInt] || '-'
  );
}

/**
 * Fat finger check.
 * Guard is percent, meaning a deviance of over 30 percent against
 * a master value (last) will fail the fat finger check.
 */
export function safeguardCheck(limit, last, guard = 30) {
  const deviation = Math.abs(100 * ((100 * (last - limit)) / last));
  guard *= 100;
  return deviation <= guard;
}
